import { Tabs, TabsProps } from "melco-ui";
import { DesignTokens } from "melco-ui";
import { UserDevicesList } from "./UserDevicesList";
import { UserHistoryList } from "./UserHistoryList";
import { useTranslation } from "react-i18next";
import { useAppDomain } from "../../../hooks/appdomain/useAppDomain";
import { UserPermissions } from "./UserPermissions";
import { UserLicensesList } from "./UserLicensesList";
import { UserLogFilesList } from "./UserLogFilesList";
import { FullWidthRow } from "../../../helper/commonHelper";
import { UserLicensesTrialsList } from "./UserLicensesTrialsList";
import { QueryObserverResult } from "react-query";
import { MelcoModelsGenericList1MelcoModelsUserProductListItem } from "melco-shared-logic";

type UserProductTabsProps = {
  selectedProduct: string;
  userId: string;
  refetchUserProducts?: () => Promise<
    QueryObserverResult<
      MelcoModelsGenericList1MelcoModelsUserProductListItem,
      unknown
    >
  >;
};

export const UserProductTabs: React.FC<UserProductTabsProps> = ({
  selectedProduct,
  userId,
  refetchUserProducts,
}) => {
  const { productTabs } = useAppDomain();
  const { spacings } = DesignTokens;

  const { t } = useTranslation();
  const onChange = (key: string) => {
    console.log(key);
  };

  let items: TabsProps["items"] = [];

  const refetchUserProductsCallBack = () => {
    if (refetchUserProducts) refetchUserProducts();
  };

  let tabsComponentsJSON: any = {
    licenses: (
      <UserLicensesList userId={userId} productCode={selectedProduct} />
    ),
    devices: <UserDevicesList userId={userId} productCode={selectedProduct} />,
    history: <UserHistoryList userId={userId} productCode={selectedProduct} />,
    permissions: (
      <UserPermissions userId={userId} productCode={selectedProduct} />
    ),
    logfiles: (
      <UserLogFilesList userId={userId} productCode={selectedProduct} />
    ),
    trials: (
      <UserLicensesTrialsList
        userId={userId}
        productCode={selectedProduct}
        refetchUserProductsCallBack={refetchUserProductsCallBack}
      />
    ),
  };

  items = productTabs[selectedProduct]
    ? productTabs[selectedProduct].split(",").map((p, i) => {
      let key = selectedProduct + i;
      let labelTitle = t(("users.tabs." + p + ".title") as any);
      return {
        key: key,
        label: labelTitle,
        children: tabsComponentsJSON[p],
      };
    })
    : [];

  return (
    <>
      <FullWidthRow gutter={[spacings.middle, spacings.middle]}>
        <Tabs style={{ width: "100%", margin: "5px 0px", }} items={items} onChange={onChange} />
      </FullWidthRow>
    </>
  );
};
